export var WorkflowStatusEnum;
(function (WorkflowStatusEnum) {
    WorkflowStatusEnum["ACTIVE"] = "ACTIVE";
    WorkflowStatusEnum["INACTIVE"] = "INACTIVE";
    WorkflowStatusEnum["ERROR"] = "ERROR";
})(WorkflowStatusEnum || (WorkflowStatusEnum = {}));
//# sourceMappingURL=workflow-status-enum.js.map